export default __webpack_public_path__ + "static/media/visualArtefacts.c15ff44b.svg";